<template>
    <footer id="footer">
        <div
            class="footer-dialog-links"
        >
            <span
                v-for="dialog in footerDialogs"
                :key="dialog.slug"
                :class="dialog.slug"
                :data-dialog="dialog.slug"
                :aria-label="`Read more about ${dialog.title}`"
                @click="show"
                v-html="dialog.title"
            />
        </div>

        <span
            v-if="footerText !== ''"
            class="footer__text"
            v-html="footerText"
        />

        <span
            class="RSP-code"
            v-html="get('tag')"
        />
    </footer>
</template>

<script>
import Page from '../../../../../../resources/frontend/js/mixins/page.vue';

export default {
    mixins: [Page],

    props: {
        dialogs: {
            type: Object,
            required: true,
        },

        footerText: {
            type: String,
            required: true,
        },
    },

    computed: {
        footerDialogs() {
            const dialogs = {};
            for(const [slug, dialog] of Object.entries(this.dialogs)) {
                if(typeof dialog.show_in_footer === 'boolean' && dialog.show_in_footer) dialogs[slug] = dialog;
                if(typeof dialog.show_in_footer === 'object' && dialog.show_in_footer !== null && dialog.show_in_footer[this.$store.state.page.pageGroupType]) dialogs[slug] = dialog;
            }

            return dialogs;
        },
    },

    methods: {
        show(event) {
            this.$store.commit('dialog/show', event.target.dataset.dialog);
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'zoe-organism-footer';
</style>
